export const NEW_NAV_V1 = "new_nav_1"
export const FO_NAVIGATION_V2 = "fo_navigation_v2"
